import CachedDictionary from '../../../services/engines/CachedDictionary';

// Plug rows keyed by rk — static settings merged with live state by PlugVueEngine
class PlugVueCache extends CachedDictionary {
    _name = 'PlugVueCache';

    /**
     * @returns {object[]} all plug rows
     */
    getAll = () => this.getKeys().map((k) => this.getKey(k));
}

const plugVueCache = new PlugVueCache();
export default plugVueCache;
